var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    className: "user_svg__nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 12.976a1 1 0 00-.426-.82A10.367 10.367 0 008 10.5a10.367 10.367 0 00-6.074 1.656 1 1 0 00-.426.82V15.5h13z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 4,
    r: 3.5
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+PGcgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgY2xhc3M9Im5jLWljb24td3JhcHBlciI+PHBhdGggZD0iTTE0LjUsMTIuOTc2YTEsMSwwLDAsMC0uNDI2LS44MkExMC4zNjcsMTAuMzY3LDAsMCwwLDgsMTAuNWExMC4zNjcsMTAuMzY3LDAsMCwwLTYuMDc0LDEuNjU2LDEsMSwwLDAsMC0uNDI2LjgyVjE1LjVoMTNaIj48L3BhdGg+IDxjaXJjbGUgY3g9IjgiIGN5PSI0IiByPSIzLjUiPjwvY2lyY2xlPjwvZz48L3N2Zz4=";
export { SvgUser as ReactComponent };